const toMs = (value: string | null | undefined): number => {
  if (!value) return Number.NEGATIVE_INFINITY;
  const ms = Date.parse(value);
  return Number.isNaN(ms) ? Number.NEGATIVE_INFINITY : ms;
};

export const isLaterIso = (a: string | null | undefined, b: string | null | undefined): boolean => {
  if (!a) return false;
  if (!b) return true;
  return toMs(a) > toMs(b);
};

export const maxIso = (a: string | null | undefined, b: string | null | undefined): string | null => {
  if (!a) return b ?? null;
  if (!b) return a ?? null;
  return toMs(a) >= toMs(b) ? a : b;
};

